import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { normalizeSession } from '../../utils/authSession';
export default function ProtectedRoute({ children }) {
  const auth = useSelector((state) => state.authSlice);
  return normalizeSession(auth).isLoggedIn ? <Navigate to="/account" replace /> : children;
}
